import React, { useEffect, useState } from "react";
import LineChart from "../../../../components/charts/LineChart";
import { useAppSelector, useAppDispatch } from "../../../../redux/app/hooks";
import { fetchMarketerEarnings } from "../../../../redux/features/EarningsSlice";

const EarningsChart = () => {
  const dispatch = useAppDispatch();
  const { marketerEarnings } = useAppSelector((state) => state.earnings);
  const [chartXAxis, setChartXAxis] = useState<string[]>([]);
  const [chartSeries, setChartSeries] = useState<number[]>([]);

  useEffect(() => {
    dispatch(fetchMarketerEarnings());
  }, [dispatch]);

  useEffect(() => {
    if (marketerEarnings.length > 0) {
      const timeline = marketerEarnings[0].earningsTimeline;

      if (!timeline || timeline.length === 0) return;

      // Sort timeline by date
      const sortedTimeline = [...timeline].sort(
        (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
      );

      // X-axis: Month name
      const months = sortedTimeline.map((item) =>
        new Date(item.date).toLocaleString("default", { month: "short" })
      );

      // Series: Earnings for that date
      const earningsData = sortedTimeline.map((item) => item.earnings);

      setChartXAxis(months);
      setChartSeries(earningsData);
    }
  }, [marketerEarnings]);

  const series = [
    {
      name: "Earnings",
      data: chartSeries,
      color: "#8b5cf6",
    },
  ];

  return (
    <div className="lg:col-span-9 space-y-6">
      <LineChart
        xAxisData={chartXAxis}
        series={series}
        height={320}
        showLegend={false}
        smooth={false}
      />
    </div>
  );
};

export default EarningsChart;
